import router from '../router/index'
import api from '@/api/api'

export function logout (currentRoute) {
    
    let routerData
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('auto');
    

    if (currentRoute.name === 'MenuItemsEdit' || currentRoute.name === 'MenuItemsCreate') {
        routerData = {name: 'Index', params: {param: {name: 'MenuItems'}}}
    } else {
        routerData = {name: 'Index', params: {param: currentRoute}}
    }

    router.push(routerData)
}

export function firstToUpper (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

export function discard (data) {
    this.$router.back();
}

export function edit (route, data, name) {
    let router = {name: '', params: { isEdit: true }}
    router.name = route
    router.params[name] = data
    
    this.$router.push(router)
}

export function getFilteredList (data) {
    this.filterLoading = true
    this.filteredData = data
    setTimeout(() => { 
        this.filterLoading = false
    }, 2000)
}

export function getRatesApiPath (provider) {
    let path = '' 
    let id = null
    let user 
    api.fetchSelf()
    .then ((res) => {
        user = res.data.data
        if (user.roles[0].name === 'provider') {
            this.$store.dispatch('fetchRates')
            user.provider ? path = `/dashboard/provider/${user.provider.id}` : path = '/dashboard/profile'
            this.$router.push(path)
        } else if (provider) {
            this.$store.dispatch('fetchProviderRates', provider)
        } else {
            this.$store.dispatch('fetchAllRates')
        }
        return path 
    })
}

//  getRatesApiPath


// WEBPACK FOOTER //
// ./src/helpers/helpers.js